import { type RotationColouring, cycleLengths, isDihedral } from '../geometry/colouring';

const factorial = (n: number): number => (n <= 1 ? 1 : n * factorial(n - 1));

/**
 * Names the colour-permutation group of a rotation colouring where it can be identified from its
 * degree and order alone (transitive groups of these degrees with these orders are unique).
 */
export function colourGroupName(c: RotationColouring): string | null {
  const { k, groupOrder: n } = c;
  if (n === k && cycleLengths(c.X).length === 1) return `the cyclic group C${sub(k)}`;
  if (k >= 3 && isDihedral(c)) return `the dihedral group D${sub(k)}`;
  if (n === factorial(k)) return `the symmetric group S${sub(k)}`;
  if (n === factorial(k) / 2 && k >= 4) return `the alternating group A${sub(k)}`;
  if (k === 7 && n === 168) return 'PSL(2,7)';
  if (k === 8 && n === 336) return 'PGL(2,7)';
  return null;
}

export function describeColourGroup(c: RotationColouring): string {
  const name = colourGroupName(c);
  return name ? `${name}, order ${c.groupOrder}` : `a group of order ${c.groupOrder}`;
}

function sub(n: number): string {
  const digits = '₀₁₂₃₄₅₆₇₈₉';
  return String(n)
    .split('')
    .map((d) => digits[Number(d)])
    .join('');
}
